/* eslint eqeqeq: "off" */
import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import toastr from 'toastr';
import ContableRegistroGastoForm from './ContableRegistroGastoForm';
import * as validations from '../../validations/validations';
import * as contableregistrogastoActions from '../../actions/contableregistrogastoActions';
import * as contablecuentaActions from '../../actions/contablecuentaActions';
import * as cursoActions from '../../actions/cursoActions';
import * as contablegastoActions from '../../actions/contablegastoActions';
import * as userActions from '../../actions/userActions';
import * as menuActions from '../../actions/menuActions';
import * as paginaActions from '../../actions/paginaActions';
import withRouter from '../common/withRouter';

import * as showSidebarIzquierdaActions from '../../actions/showSidebarIzquierdaActions';
import { Segment} from 'semantic-ui-react';
import {genericFormattedForDropdown} from '../../selectors/selectors';
import moment from 'moment';
import {getMargenes} from '../../util/';
import $ from 'jquery';
import dayjs from 'dayjs';
import {usuarioActual} from '../../util';

class ManageContableRegistroGastoForm extends React.Component {

    constructor(props, context){
		super(props, context);
		this.state={
            errors:{},
            permisos:{},
			contableregistrogasto:{
                fechaRegistro: new moment().format('DD/MM/YYYY'),
            }
		};
		
	}
    
    
    componentDidMount(){
        
         usuarioActual(this, "ContableRegistroGasto",true).then( (usuario)=>{
        
                let id=this.props.id;

                this.props.contablecuentaActions.getContableCuentaCombo(usuario).then( ()=>{ 
           
                   }) 
                    .catch(error=>{ 
                      toastr.error(error); 
                    }); 
             
                this.props.contablegastoActions.getContableGastoCombo(usuario).then( ()=>{ 
           
                   }) 
                    .catch(error=>{ 
                      toastr.error(error); 
                    });
             
             
                 this.props.cursoActions.getCursoCombo(usuario).then( ()=>{ 
           
                   }) 
                    .catch(error=>{ 
                      toastr.error(error); 
                    });
             

                this.props.showSidebarIzquierdaActions.sidebarIzquierda(true);  
               

                if(id && id>0 ){

                   this.props.contableregistrogastoActions.getContableRegistroGasto(id, usuario).then( contableregistrogasto=>{
                       
                       
                       if(contableregistrogasto.fechaRegistro!=null){
                            contableregistrogasto.fechaRegistro= new moment(contableregistrogasto.fechaRegistro).format('DD/MM/YYYY');    
                        }else{
                            contableregistrogasto.fechaRegistro= new moment().format('DD/MM/YYYY'); 
                        }

                       
                       this.setState({"contableregistrogasto":contableregistrogasto});
                   })
                    .catch(error=>{
                      toastr.error(error);
                    }); 
                }
         })
        .catch(error=>{
          toastr.error(error);
        }); 
		
    }
    

    handleChange=(event, data)=> {

        let contableregistrogasto = this.state.contableregistrogasto;
        let field= data.name;		
        let value;
    
        if(data.type == 'radio'){
            value=	data.checked;		
        }else{
            value=	data.value;		
        }
        
        if(data.toggle){
            if(data.checked){
                value = 1;
            }else{
                 value = 2
            }
        }
        
        
        field=field.split('.');
		if(field.length==1)
      		contableregistrogasto[field[0]]= value;
		else{
             if(!contableregistrogasto[field[0]]){
                    contableregistrogasto[field[0]]={}
                }
			contableregistrogasto[field[0]][field[1]]= value;
		}
        
		
        this.setState({"contableregistrogasto": contableregistrogasto});
    }
    
    
    FormIsValid(){
        let formIsValid=true;
        let falla="";
        let errors={};
            
        let contableregistrogasto=this.state.contableregistrogasto;
              
        if(!validations.requerido(contableregistrogasto.comentario)){
            errors.comentario=true;
            formIsValid=false;
        }
       
        if(!validations.requerido(contableregistrogasto.fechaRegistro)){
            errors.fechaRegistro=true;
            formIsValid=false;
        }
       
        if(!validations.requerido(contableregistrogasto.monto)){
            errors.monto=true;
            formIsValid=false;
        }
       
        if(!validations.requerido(contableregistrogasto.contableCuentaId)){
            errors.contableCuentaId=true;
            formIsValid=false;
        }
       
        if(!validations.requerido(contableregistrogasto.contableGastoId)){
            errors.contableGastoId=true;
            formIsValid=false;
        }
       
       
        
        this.setState({
            "errors":errors
        });
        
        if(!formIsValid){
			toastr.error("Debes capturar la información requerida.");
        }
    
        return formIsValid;
    }


    fechas=(fechasArreglo, fechasCadena)=>{
        console.log(fechasArreglo);
        let contableregistrogasto = this.state.contableregistrogasto;
        contableregistrogasto.fechaRegistro = fechasCadena;
        contableregistrogasto.fechadayJs = fechasArreglo;
             //new moment(fechasCadena).format("MM-DD-YYYY");
             //this.state.nuevo.fechaInicioExamen[0].format("DD-MM-YYYY");
        this.setState({contableregistrogasto:contableregistrogasto});
    }


    onSave=(event)=>{
        event.preventDefault();
        if(!this.FormIsValid()){
            return ;
        }
       
        
        let newState=Object.assign({}, this.state.contableregistrogasto);
        
        
        /*
        if(moment.isMoment(newState.fechaRegistro)){
            newState.fechaRegistro = new moment(newState.fechaRegistro).format('YYYY/MM/DD hh:mm:ss');
        }else{
            newState.fechaRegistro = moment(newState.fechaRegistro, 'DD/MM/YYYY'); 
            newState.fechaRegistro = new moment(newState.fechaRegistro).format('YYYY/MM/DD hh:mm:ss');
        }
        */
        
        console.log(newState.fechadayJs);
        newState.fechaRegistro = dayjs(newState.fechadayJs).format('YYYY/MM/DD hh:mm:ss');
        console.log(newState.fechaRegistro);
        this.props.contableregistrogastoActions.save(newState, this.props.user).then(() => {
            toastr.success("Registro guardado!!!.");
             this.props.navigate(-1);
        });
        
    }

       
    render() {	
          
   let margenes=getMargenes(this.props.showSidebarIzquierda, this.props.sidebarIzquierda);
		 		return (
              <Segment  style={margenes}>
                <ContableRegistroGastoForm 
                    strings={this.state.strings}
                    id={this.props.id}
                    onChange={this.handleChange}
                    errors={this.state.errors}
                    datos={this.state.contableregistrogasto}
                    onSave={this.onSave}      
                    ajaxCallInProgress={this.props.ajaxCallInProgress}
                    color={this.props.color}
                    form={this.props.form}
                    permisos={this.state.permisos}
                    contablecuentaCombo={genericFormattedForDropdown(this.props.contablecuentaCombo)}
                    contablegastoCombo={genericFormattedForDropdown(this.props.contablegastoCombo)}
                    cursoCombo={genericFormattedForDropdown(this.props.cursoCombo)}
                    fechas={this.fechas}
                />

            </Segment> 
		);
	}
    
}

            
            
function mapStateToProps(state, ownProps, match ){
    return {        
            ajaxCallInProgress:state.ajaxCallInProgress,
            showSidebarIzquierda: state.showSidebarIzquierda,
            sidebarIzquierda: state.sidebarIzquierda, 
            color:state.color,
            user:state.user, 
            idioma:state.idioma,
            form:state.form,
            contablecuentaCombo:state.contablecuentaCombo,
            contablegastoCombo:state.contablegastoCombo,
            cursoCombo:state.cursoCombo
    }

}

function mapDispatchToProps(dispatch){

	return {   
            showSidebarIzquierdaActions: bindActionCreators(showSidebarIzquierdaActions, dispatch),
            paginaActions: bindActionCreators(paginaActions, dispatch),
            userActions: bindActionCreators(userActions, dispatch),
            contableregistrogastoActions: bindActionCreators(contableregistrogastoActions, dispatch),
            contablecuentaActions: bindActionCreators(contablecuentaActions, dispatch),
            contablegastoActions: bindActionCreators(contablegastoActions, dispatch),
            menuActions:bindActionCreators(menuActions, dispatch),
            cursoActions:bindActionCreators(cursoActions, dispatch),
	};
}


export default connect (mapStateToProps, mapDispatchToProps)(withRouter(ManageContableRegistroGastoForm));